// middleware/auth.ts
import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useRuntimeConfig, useLocalePath } from '#imports'
import useAuth from '~/composables/auth/useAuth'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.meta.requiresAuth) return

  const localePath = useLocalePath()
  const { appEnv } = useRuntimeConfig().public

  // skip in dev mode, because cookies is not secure
  if (process.server && appEnv !== 'production') {
    return
  }

  const { isAuthenticated, verifyToken } = useAuth()

  // already authenticated
  if (isAuthenticated.value) return

  // try to verify token and fetch profile
  await verifyToken()

  // if not authenticated
  if (!isAuthenticated.value) {
    return navigateTo(
      localePath(`/login?redirectTo=${encodeURIComponent(to.fullPath)}`)
    )
  }
})
